export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14315.615a4ad0.jpg";